import { audits } from "./audits";
import { barReports } from "./bar-reports";
import { businessIntelligence } from "./business-intelligence/";
import { discountCategory } from "./discount-category";
import { emissionErrors } from "./emission-errors";
import { emited } from "./emited";
import { entrance } from "./entrance";
import { entranceBilling } from "./entrance-billing/";
import { events } from "./events/";
import { extract } from "./extract";
import { passwordCard } from "./password-card";
import { notEmitedProducts } from "./not-emited-products";
import { promotion } from "./promotion";
import { search } from "./search";
import { transactions } from "./transactions";
import { recharges } from "./recharges";
import { invoicesIva } from "./invoices-iva";
import { invoicesNational } from "./invoices-national";
import { invoicesBackups } from "./invoices-backups";
import { kardex } from "./kardex";
import { multivendor } from "./multivendor";
import { coala } from "./coala";
import { financialReport } from "./financial-report/";
import { fiscalReport } from "./fiscal-report";
import { guestList } from "./guest-list/";
import { pos } from "./pos";
import { products } from "./products";
import { productMenu } from "./product-menu";
import { tagGroups } from "./tag-groups";
import { promotions } from "./promotions";
import { settings } from "./settings";
import { storage } from "./storage/";
import { whatsUp } from "./whats-up";
import { importXml } from "./import-xml";
import { reserve } from "./reserve";
import { productDetail } from "./products/product-detail";
import { productArea } from "./products/product-area";
import { inventoryControl } from "./inventory-control";
import { prechargeReports } from "./precharge-reports";
import { contracts } from "./contracts";
import { rechargeManagement } from "./recharge-management";
import { BONUS_CATEGORIES_EN_US } from "#pages/place/bonus-categories/translations/bonus-categories-en-us";
import { kds } from "./kds";
import { IMPORT_EN_US } from "#pages/place/purchase-invoice/import-invoice/translations/import-en-us";
import { PURCHASE_INVOICE_EN_US } from "#pages/place/purchase-invoice/translations/purchase-invoice-en-us";
import { delivery } from "./delivery";
import { EXTRACT_EN_US } from "#pages/place/extract-new/translations";
import { USER_BONUS_TABLE_EN_US } from "#components/tables/reports/user-bonus-table/translations";
import { BONUS_REPORT_EN_US } from "#pages/place/financial-reports/bonus-report/translations";
import { BONUS_REPORT_FOR_PLACE_EN_US } from "#pages/place/financial-reports/bonus-report-for-place/translations";
import { placeData } from "./place-data";
import { barsAndSectors } from "./bars-and-sectors";
import { precharge_EN_US } from "#pages/place/precharge/pages/translations";
import { TRANSACTIONS_REPORT_EN_US } from "#components/transactions-report/translations";

export const placeEN = {
	placeTitle: "Places",
	searchPlaceInputPlaceholder: "Search for a place",
	placeWithoutEvent: "Places without event for more than a month",
	placeWithOpenEvent: "Places with an event in progress",
	placeWithoutEventInProgress: "Places without an event in progress",
	timezone: "Timezone",
	currency: "Currency",
	subtitle: "Legend",
	alphabeticalOrder: "Alphabetical order",
	lastEventOrder: "Last event created",
	initialDefaultDateOrder: "Default date filter",
	financialFile: {
		title: "Financial file",
		description: "Track your equipment and subscription requests.",
		titleDescription: "Description",
		table: {
			columns: {
				name: "Name",
				contractId: "Contract",
				period: "Period",
			},
		},
		downloadButton: "Download",
		eventType: {
			festival: "Festival",
			fixedVenue: "Fixed House",
			event: "Event",
			sports: "Sports",
			fairs: "Fairs",
			beachClub: "Beach Club",
			retail: "Retail",
			bar: "Bar",
			others: "Other",
			hotel: "Hotel",
			restaurant: "Restaurant",
			school: "School",
			arena: "Arena (Stadium)",
			hospitality: "Hospitality",
			nightclub: "Nightclub",
			barRestaurant: "Bar & Restaurant",
			beachTennisCourt: "Beach Tennis Court",
			carnival: "Carnival",
			juneParty: "June Party",
			musicFestival: "Music Festival",
			show: "Concert",
			newYearsEve: "New Years Eve",
			eventVenue: "Event venue",
			musicShow: "Music concert",
			sportsEvent: "Sports event",
			gastronomicEvent: "Gastronomic Event",
			religiousEvent: "Religious event",
			schoolEvent: "School event",
			seasonalHouse: "Temporary House",
		},
		eventModel: {
			monthly: "Monthly",
			weekly: "Weekly",
			oneTime: "Single",
		},
		invoiceType: {
			daily: "Daily",
			weekly: "Weekly",
			monthly: "Monthly",
			atTermination: "At the End",
			perSession: "Per Session",
		},
		financialClosingTitle: "Financial Closing",
		zigDataSection: "Data - Zig",
		currency: "Currency",
		document: "Document",
		name: "Name",
		address: "Address",
		eventDataSection: "Data - Event",
		period: "Period",
		notInformed: "Not informed",
		type: "Type",
		zigExecutive: "Zig Executive",
		model: "Model",
		billing: "Billing",
		automaticRepayment: "Automatic Repayment",
		yes: "Yes",
		no: "No",
		placeId: "PlaceId",
		organizationId: "OrganizationId",
		clientDataSection: "Data - Client",
		client: "Client",
		contract: "Contract",
		contractValidity: "Contract Validity",
		eventBillingHeader: "Billing - Event",
		value: "Value",
		total: "Total",
		totalBilling: "Total Billing",
		zigBillingHeader: "Billing - Zig",
		item: "Item",
		base: "Base",
		taxRate: "Rate (%)",
		zigInvoiceSummary: "Zig Invoice Summary",
		finalResultHeader: "Final Result",
		integratedAcquiringBalance: "Balance generated by Integrated Acquiring",
		nonIntegratedAcquiringBalance: "Balance generated by Non-Integrated Acquiring",
		zigInvoice: "Zig Invoice",
		balanceToTransfer: "Balance to Transfer",
		finalBalanceToTransfer: "Final Balance to Transfer",
		technicalAnalysisHeader: "Technical Analysis",
		previousValue: "Previous Value",
		newValue: "New Value",
		issuance: "Issuance",
		date: "Date",
		version: "Version",
		meta: "Meta",
		others: "Others",
		eventEntries: "Event Entries",
		totalBalance: "Total Final",
		tpvOthers: "POS Others",
		integratedAcquiring: "Integrated Acquiring",
		nonIntegratedAcquiring: "Non-Integrated Acquiring",
		zigBilling: "ZIG Billing",
		balanceMovement: "Balance Movement",
		to: "to",
	},
	subtitles: {
		onGoingEvent: "Ongoing event",
		recentEvent: "Recent event",
		longTimeWithoutEvent: "Long time without event",
		waitingForApproval: "Waiting for approval",
		noEvent: "No event",
	},
	placelinks: {
		post: "Post",
		pre: "Pre",
		noEvents: "Without events",
		none: "No event",
		openEvent: "Open event",
	},
	placeTabs: {
		products: " Products",
		combos: " Combos",
		supplies: " Inputs",
		bars: " Bars",
		beer: " Draft Beer",
		gng: " Grab and Go",
		cmv: " Eng. from Menu",
		config: "Menu Settings",
	},
	events,
	products,
	productMenu,
	businessIntelligence,
	entranceBilling,
	reserve,
	storage,
	financialReport,
	guestList,
	entrance,
	tagGroups,
	pos,
	promotions,
	whatsUp,
	audits,
	settings,
	precharge: precharge_EN_US,
	barReports,
	extract,
	passwordCard,
	notEmitedProducts,
	promotion,
	search,
	transactions,
	invoicesIva,
	invoicesNational,
	invoicesBackups,
	kardex,
	multivendor,
	coala,
	fiscalReport,
	discountCategory,
	emissionErrors,
	emited,
	importXml,
	productDetail,
	productArea,
	inventoryControl,
	prechargeReports,
	contracts,
	rechargeManagement,
	recharges,
	transactionsReport: TRANSACTIONS_REPORT_EN_US,
	bonusCategories: BONUS_CATEGORIES_EN_US,
	kds,
	purchaseInvoiceV2: PURCHASE_INVOICE_EN_US,
	import: IMPORT_EN_US,
	delivery,
	extractNew: EXTRACT_EN_US,
	userBonusTable: USER_BONUS_TABLE_EN_US,
	bonusReport: BONUS_REPORT_EN_US,
	bonusReportForPlace: BONUS_REPORT_FOR_PLACE_EN_US,
	placeData,
	barsAndSectors,
};
